import React, { ChangeEvent } from 'react';

type Props =  {
  label: string;
  value: number;
  max?: number;
  min?: number;
  step?: number;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const Slider = ({ label, onChange, value, min=0, max=100, step=0.1 }: Props): JSX.Element => (
  <div className='flex flex-col'>
    <label htmlFor='default-range' className='block mb-2 text-sm font-medium'>{label}</label>
    <input onChange={onChange} id='default-range' type='range' step={step} min={min} max={max} value={value} className='w-full h-2 bg-emerald-100 accent-emerald-700 rounded-lg appearance-none cursor-pointer' />
  </div>
);
